<div class="snapshot-container" #snapshotContainer>
  <div class="snapshot-operations">
    <div class="operations-row">
      <button mat-raised-button id="enable-camera-button" aria-label="Capture Image"
        (click)="enableSnapshot()"
        [matTooltip]="'LABELS.TAKEAPHOTO' | translate"
        [hidden]="(!AS.appModes.includes(appModes.Photo)) || AS_video.captureUrl || AS_video.cameraEnabledForSnapshot"
        [disabled]="!MYSTATUS.isRegistered || AS.sessionExpired || !atLeast1Camera">
        <span class="button-svg font-icon-button material-symbols-outlined">photo_camera</span>
        <!-- <span class="no-camera" *ngIf="!atLeast1Camera || AS.mediaPermission == 2">{{'LABELS.NOCAMERA' | translate}}</span> -->
      </button>

      <button mat-raised-button id="gallery-button" [matTooltip]="'LABELS.GETFROMGALLERY' | translate"
        (click)="openImageGalleryInput()"
        [hidden]="(!AS.appModes.includes(appModes.Photo)) || AS_video.captureUrl || AS_video.cameraEnabledForSnapshot"
        [ngClass]="{'disabled-label': !MYSTATUS.isRegistered || AS.sessionExpired}">
        <span class="button-svg font-icon-button material-symbols-outlined">collections</span>
      </button>
      <input id="imageUploader" type="file" style="display: none;" [disabled]="!MYSTATUS.isRegistered || AS.sessionExpired"
        accept="image/*" #fileInput (change)="onImageGalleryChange($event)" (cancel)="onFilePickerCancel()" />
    </div>
    <div class="operations-row">
      <button mat-raised-button id="zz-button" [matTooltip]="'LABELS.SENDATTACHMENT' | translate"
        (click)="openFileInput('attachmentUploader')"
        [hidden]="(!AS.appModes.includes(appModes.Photo)) || AS_video.captureUrl || AS_video.cameraEnabledForSnapshot"
        [ngClass]="{'disabled-label': !MYSTATUS.isRegistered || AS.sessionExpired}">
        <span class="button-svg font-icon-button material-symbols-outlined">attach_file</span>
      </button>
      <input id="attachmentUploader" type="file" style="display: none;" accept="{{config.supportedExtensions}}" #fileInput
        (change)="attachDocument($event)" (cancel)="onFilePickerCancel()"
        [disabled]="!(AS.session) || AS.sessionExpired" />
    </div>
  </div>



  
  <video id="localVideoSnapshot" oncontextmenu="return false;" #localVideoSnapshot playsinline
    [hidden]="!AS_video.cameraEnabledForSnapshot || !atLeast1Camera || AS.mediaPermission == 2">
  </video>

  <div class="no-permission-overlay"
    *ngIf="AS_video.cameraEnabledForSnapshot && (!atLeast1Camera || AS.mediaPermission == 2) ">
    <span class="font-icon-outlined material-symbols-outlined">videocam_off</span>
    <span class="no-permission-text">{{'LABELS.NOCAMERA' | translate}}</span>
  </div>

  <button aria-label="Switch Camera" (click)="switchCamera()"
    class="roundborder-dark-background-button switch-camera-button-caller"
    [hidden]="(!AS.appModes.includes(appModes.Photo)) || !AS_video.cameraEnabledForSnapshot || AS_video.captureUrl || !doubleCamera"
    [matTooltip]="(config.isMobilePhone ? 'LABELS.FLIPCAMERA' :'LABELS.SWITCHCAMERA') | translate"
    [disabled]="!MYSTATUS.isRegistered || AS.sessionExpired || AS.mediaPermission == 2">
    <span class="font-icon-button-big material-symbols-outlined">switch_camera</span>
  </button>

  <button id="capture-button" *ngIf="atLeast1Camera && AS.mediaPermission != 2" aria-label="Capture Image"
    (click)="captureVideoImage()" class="roundborder-dark-background-button"
    [hidden]="(!AS.appModes.includes(appModes.Photo)) || AS_video.captureUrl || !AS_video.cameraEnabledForSnapshot"
    [disabled]="!MYSTATUS.isRegistered || AS.sessionExpired">
    <span class="font-icon-button-big material-symbols-outlined">radio_button_checked</span>
  </button>

  <button id="cancel-button" aria-label="Back" (click)="disableSnapshot()" class="roundborder-red-background-button"
    [hidden]="(!AS.appModes.includes(appModes.Photo)) || !AS_video.cameraEnabledForSnapshot || AS_video.captureUrl"
    [disabled]="!MYSTATUS.isRegistered || AS.sessionExpired">
    <span class="font-icon-button-big material-symbols-outlined">clear</span>
  </button>

  <canvas #canvas id="canvas"></canvas>
  <img id="capture" [hidden]="!AS_video.captureUrl || (!AS.appModes.includes(appModes.Photo))"
    src="{{AS_video.captureUrl}}" [ngClass]="{'img-height': higher, 'img-width': !higher}">

  <button id="back-button" aria-label="Back" (click)="backToVideo()" class="roundborder-dark-background-button"
    [hidden]="(!AS.appModes.includes(appModes.Photo)) || !AS_video.captureUrl"
    [disabled]="!MYSTATUS.isRegistered || AS.sessionExpired">
    <span class="font-icon-button-big material-symbols-outlined">arrow_back</span>
  </button>

  <button id="send-image-button" aria-label="Send Image" (click)="sendCameraImage()" class="roundborder-dark-background-button"
    [hidden]="(!AS.appModes.includes(appModes.Photo)) || !AS_video.captureUrl"
    [disabled]="!MYSTATUS.isRegistered || AS.sessionExpired || uploading">
    <span class="font-icon-button-big material-symbols-outlined">send</span>
  </button>
</div>
